import { useEffect, useState } from "react";
import { apiHelper } from "../lib/ApiHelper";
import OverRideConfirmation from "./OverRideConfirmation";

export default function popUp(props) {
    const [isPrivate, setISPrivate] = useState(true);

    const [overrideConfirmation, setoverrideConfirmation] = useState(false);

    const saveTitleList = async() => {

        props.setUpdating(true);
        titleAlert("Updating Title List...", "updateUser", 'response');
        const inputText = document.getElementById('inputText').value;
        if (inputText == "" || inputText == null) {
            titleAlert("Please enter title list name", "errorUser", 'response');
            props.setUpdating(false);
            return;
        }
        if (!props.titleList && props.titleList.length <= 0) {
     
            await props.saveTitleList(inputText, props.isNewTitleList, null, isPrivate);
            return;
        } else {
            const item = props.titleList.find(i => (i.listname === inputText && i.isowner == true));

            if (item != undefined && item) {
                if (props.isNewTitleList && item.isprivate == isPrivate) {
   
                    setoverrideConfirmation(true);
                } else if (props.isNewTitleList) {
           
                   await props.saveTitleList(inputText, props.isNewTitleList, item.listid, isPrivate);
                } else if (item.listid == props.titleSelected) {
         
                   await props.saveTitleList(inputText, false, item.listid, isPrivate);
                } else {
                    titleAlert("List name already exist", "errorUser", 'response');
                    props.setUpdating(false);
                }
            }
            else {

                await props.saveTitleList(inputText, props.isNewTitleList, null, isPrivate);
            }

        }



    }
    const onClose = () => {
        setoverrideConfirmation(false);
        props.setUpdating(false);
        setAlertMessage("");
    }


    const extractISBNs = async () => {
        try {
            props.setUpdating(true);
            titleAlert("Updating ISBNs List...", "updateUser", 'response');
            const inputText = document.getElementById('inputText').value;
            if (inputText == "") {
                props.setIsbnData({
                    listISBN: [],
                    Loading: false,
                    duplicates: [],
                    invalid: []
                });
                props.setISBNId('');
                await apiHelper.handleReplaceList([], props.upn, true);
            } else {
                const prepend = false;
                const formOverview = true;
                const updateSetTitle = true;
                await apiHelper.ISBNCheckValidate(inputText, props.upn, props.setIsbnData, props.isbnData, prepend, formOverview, updateSetTitle);

            }
            props.closeTitlePopUp();
            titleAlert("", "updateUser", 'response');
        } catch {
            titleAlert("Updating ISBNs failed !", "errorUser", 'response');
        } finally {
            props.setUpdating(false);
        }
    }

    const clearISBN = async () => {
        try {
            document.getElementById('inputText').value = '';
        } catch (error) {
            console.error("Clear title failed", error);
        }
    }
    const titleAlert = (message, className = 'info') => {
        try {
            props.setAlertMessage(message);
            props.setmessageCSS(className);
        } catch { console.error("Update alert failed"); }
    }
    const onOverRide = () => {
        setoverrideConfirmation(false);
        const inputText = document.getElementById('inputText').value;
        const item = props.titleList.find(i => i.listname === inputText && i.isowner && i.isprivate == isPrivate);
        props.saveTitleList(inputText, false, item.listid, isPrivate);
        // props.saveTitleList(inputText, false);
    }
    useEffect(() => {
        setISPrivate(props.titleIsPrivate ?? true);

        if (props.isTitleListPopUp) {
            if (!props.isNewTitleList) {
                document.getElementById('inputText').value = props.title;
            }
        }
        else
            document.getElementById('inputText').value = (props.isbnData.listISBN.map(i => i.isbn).join('\n'));

    }, [])


    return (
        <>

            <div className="popup-overlay container-fluid" hidden={overrideConfirmation}>
                <div className="popup" style={{ overflowY: "auto" }}>
                    <div className="popup-header-inline">
                        <span className="popup-header-title">   {props.isTitleListPopUp ? (props.isNewTitleList ? 'Save As' : 'Save') : 'ISBN List'}</span><button className="popup-close-btn" onClick={props.closeTitlePopUp} disabled={props.isUpdating}></button>
                    </div>
                    {props.isTitleListPopUp ? (
                        <div className="popup-content p-3" style={{ display: "grid" }} >
                            <>< span className="box-label">  {props.isNewTitleList && props?.title != null && props?.title != '' && <>Current List Name: {props?.title}</>}</span> </>
                            <input type="text" id="inputText" placeholder="List Name" className="title-box" disabled={props.isUpdating} onChange={() => props.setAlertMessage("")}></input>
                            <div className="checkbox-inline ml-1">
                                <input type="checkbox" value={isPrivate} checked={isPrivate} onClick={() => { setISPrivate(prev => !prev); props.setAlertMessage("") }} disabled={props.isUpdating || (!props.isNewTitleList && !props.isOwner)}></input>
                                <span style={{ alignContent: "center", marginLeft: "3px", fontSize: "10pt" }}> Private</span>
                            </div>
                            {/*   <div style={{ marginLeft: "auto", marginRight: "auto" }} id="response">sdjk</div>
                            <div className="titlePopupDiv">
                                <button className="titlePopupBtn" onClick={saveTitleList} >Save</button>
                                <button className="titlePopupBtn" onClick={() => props.setTitlePopUp(false)} >Cancel</button>
                            </div>*/}
                            <div style={{ marginLeft: "auto", marginRight: "auto" }} className={`${props.messageCSS}`} id="response">&nbsp;{props.alertMessage}</div>
                            <div style={{ marginLeft: "auto", marginRight: "auto" }}>
                                <button className="ISBNSubmit ml-0" onClick={saveTitleList} disabled={props.isUpdating || props.titleListLoading}>Save</button>
                                <button className="ISBNSubmit" onClick={props.closeTitlePopUp} disabled={props.isUpdating}>Close</button>
                            </div>
                        </div>
                    ) : (
                        <div className="popup-content"  >
                            <textarea id="inputText" className="resizable-textarea" placeholder="Paste ISBNs here..."></textarea>
                            <div style={{ marginLeft: "auto", marginRight: "auto", display: "table" }}>
                                    <div style={{ marginLeft: "auto", marginRight: "auto" }} className={`${props.messageCSS}`} id="response">&nbsp;{props.alertMessage}</div>
                                <button className="ISBNSubmit ml-0" onClick={extractISBNs} disabled={props.isUpdating}>Update Title List</button>
                                <button className="ISBNSubmit" onClick={clearISBN} disabled={props.isUpdating} >Clear List</button>
                            </div>
                        </div>
                    )}

                </div>

            </div>
            {overrideConfirmation && <div className="popup-content"  >
                <OverRideConfirmation onClose={onClose} onOverRide={onOverRide} titleName={document.getElementById('inputText').value} ></OverRideConfirmation>

            </div>}
        </>
    )
}